module.exports = __webpack_public_path__ + "static/media/ph_clipboard_large.3fc04e45.png";